// extracted by mini-css-extract-plugin
export default {"Image":"FaultDetails_Image__uGXIE","ImageWrapper":"FaultDetails_ImageWrapper__RNRIc","ImagesContainer":"FaultDetails_ImagesContainer__YJphF"};